export const generateKeyForStorage = (formationId, sessionId, sessionBlockId, trackId) => {
	return `expressionAnswer-${formationId}-${sessionId}-${sessionBlockId}-${trackId}`;
};
